export const ASSETS_ICONS_FALLBACK_URL =
  "https://dropstab.com/images/asset-icon-fallback-dark.svg";

export const ASSETS_ICONS_MAP = {
  "2Z": "doublezero.png",
  "0G": "0g.jpg",
  AAVE: "aave.png",
  ACE: "fusionist.png",
  ADA: "cardano.svg",
  AI16Z: "ai16z.jpeg",
  AIXBT: "aixbt-by-virtuals.png",
  ALGO: "algorand.jpg",
  ALT: "altlayer.jpg",
  ANIME: "anime-coin.jpg",
  APE: "apecoin-1.svg",
  APEX: "apex-token-2.png",
  APT: "aptos.svg",
  AR: "arweave.svg",
  ARB: "arbitrum.svg",
  ARK: "ark.svg",
  ASTER: "aster-2.jpg",
  ATOM: "cosmos.svg",
  AVAX: "avalanche-2.svg",
  AVNT: "avantis.png",
  BABY: "babylon.png",
  BANANA: "banana-gun.png",
  BCH: "bitcoin-cash.svg",
  BERA: "berachain.svg",
  BIGTIME: "big-time.svg",
  BIO: "bio-protocol.svg",
  BLAST: "blast-l2.svg",
  BLUR: "blur.png",
  BNB: "binancecoin.png",
  BOME: "book-of-meme.svg",
  BRETT: "based-brett.png",
  BSV: "bitcoin-cash-sv.svg",
  BTC: "bitcoin.svg",
  CAKE: "pancakeswap-token.svg",
  CELO: "celo.svg",
  CFX: "conflux-token.svg",
  CHILLGUY: "chill-guy.jpeg",
  COMP: "compound-governance-token.svg",
  CRV: "curve-dao-token.svg",
  DOGE: "dogecoin.png",
  DOOD: "doodles.png",
  DOT: "polkadot.svg",
  DYDX: "dydx.svg",
  DYM: "dymension.png",
  EIGEN: "eigenlayer.png",
  ENA: "ethena-labs.svg",
  ENS: "ethereum-name-service.png",
  ETC: "ethereum-classic.svg",
  ETH: "ethereum.svg",
  ETHFI: "ether-fi.png",
  FARTCOIN: "fartcoin.jpeg",
  FET: "fetch-ai.jpg",
  FIL: "filecoin.svg",
  FTT: "ftx-token.svg",
  FXS: "frax-share.svg",
  GALA: "gala.svg",
  GAS: "gas.svg",
  GMT: "stepn.png",
  GMX: "gmx.png",
  GOAT: "goatseus-maximus.jpg",
  GRASS: "grass.png",
  GRIFFAIN: "griffain.png",
  HBAR: "hedera-hashgraph.svg",
  HEMI: "hemi-network.svg",
  HMSTR: "hamster-kombat.png",
  HYPE: "hyperliquid.png",
  HYPER: "hyperlane.png",
  IMX: "immutable-x.svg",
  INIT: "initia.png",
  INJ: "injective-protocol.svg",
  IO: "io-net.png",
  IOTA: "iota.svg",
  IP: "story.png",
  JTO: "jito-network.png",
  JUP: "jupiter-station.svg",
  KAITO: "kaito.jpg",
  KAS: "kaspa.svg",
  kBONK: "bonk.svg",
  kDOGS: "dogs-community.svg",
  kFLOKI: "floki-inu.svg",
  kLUNC: "terra-luna.svg",
  kNEIRO: "neiro-3.jpg",
  kPEPE: "pepe.jpg",
  kSHIB: "shiba-inu.svg",
  LAUNCHCOIN: "omni-network.svg",
  LAYER: "solayer.png",
  LDO: "lido-dao.svg",
  LINEA: "linea.png",
  LINK: "chainlink.svg",
  LTC: "litecoin.svg",
  MANTA: "manta-network.svg",
  MAV: "maverick-protocol.png",
  MAVIA: "heroes-of-mavia.png",
  ME: "magic-eden.jpg",
  MELANIA: "melania-trump.png",
  MEME: "meme-coin.png",
  MERL: "merlin-chain.png",
  MEW: "cat-in-a-dogs-world.jpeg",
  MINA: "mina-protocol.png",
  MKR: "maker.png",
  MNT: "mantle.svg",
  MOODENG: "moo-deng.png",
  MORPHO: "morpho.svg",
  MOVE: "movement.jpg",
  NEAR: "near.svg",
  NEIROETH: "neiro-on-eth.png",
  NEO: "neo.png",
  NIL: "nillion.png",
  NOT: "notcoin.png",
  NXPC: "nexpace.png",
  OGN: "origin-protocol.svg",
  OM: "mantra-dao.png",
  OMNI: "omni-network.svg",
  ONDO: "ondo-finance.png",
  OP: "optimism.svg",
  ORDI: "ordinals.png",
  PAXG: "pax-gold.svg",
  PENDLE: "pendle.svg",
  PENGU: "pudgy-penguins.jpg",
  PEOPLE: "constitutiondao.png",
  PNUT: "peanut-the-squirrel.jpg",
  POL: "polygon-ecosystem-token.png",
  POLYX: "polymesh.png",
  POPCAT: "popcat.png",
  PROMPT: "wayfinder.jpg",
  PROVE: "succinct.svg",
  PUMP: "pump-fun.jpeg",
  PURR: "purr-2.png",
  PYTH: "pyth-network.svg",
  RENDER: "render-token.svg",
  REQ: "request-network.svg",
  RESOLV: "resolv-labs.jpg",
  REZ: "renzo-protocol.svg",
  RSR: "reserve-rights-token.png",
  RUNE: "thorchain.svg",
  S: "sonic-labs.jpg",
  SAGA: "saga-2.png",
  SAND: "the-sandbox.svg",
  SCR: "scroll.svg",
  SEI: "sei-network.svg",
  SKY: "sky-money.jpg",
  SNX: "havven.svg",
  SOL: "solana.svg",
  SOPH: "sophon.png",
  SPX: "spx6900.png",
  STBL: "stbl.svg",
  STG: "stargate-finance.png",
  STRK: "starknet.svg",
  STX: "stacks.png",
  SUI: "sui.svg",
  SUPER: "superfarm.png",
  SUSHI: "sushi.png",
  SYRUP: "syrup.png",
  TAO: "bittensor.png",
  TIA: "celestia.svg",
  TNSR: "tensor.png",
  TON: "the-open-network.svg",
  TRB: "tellor.png",
  TRUMP: "maga.png",
  TRX: "tron.svg",
  TST: "test-token.jpg",
  TURBO: "turbo.jpeg",
  UMA: "uma.svg",
  UNI: "uniswap.svg",
  USDC: "arbitrum.svg",
  USDT: "tether.svg",
  USTC: "terrausd.svg",
  USUAL: "usual.png",
  VINE: "vine-coin.png",
  VIRTUAL: "virtual-protocol.jpg",
  VVV: "venice.jpg",
  W: "wormhole.svg",
  WCT: "walletconnect.png",
  WIF: "dogwifcoin.png",
  WLD: "worldcoin.svg",
  WLFI: "world-liberty-financial.jpg",
  XAI: "xai-games.png",
  XLM: "stellar.jpg",
  XPL: "plasma.png",
  XRP: "ripple.svg",
  YGG: "yield-guild-games.png",
  YZY: "yzy.jpg",
  ZEC: "zcash.svg",
  ZEN: "zencash.svg",
  ZEREBRO: "zerebro.jpg",
  ZETA: "zetachain.png",
  ZK: "zksync.svg",
  ZORA: "zora.jpg",
  ZRO: "layerzero.png",
} as const;
